export default __webpack_public_path__ + "img/dcNDXtDG.2fac1776.svg";